import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommGroupList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCGroup: DataSource;
    tableMCGroup: Table;
}
